import axiosInstance from "~/shared/api/axios-instance";

export const reorderFloorPlans = async (params: {
  branchUid: string;
  versionId?: number;
  floorPlanIds: number[];
}) => {
  const { data } = await axiosInstance.patch(
    `branches/${params.branchUid}/floor-plans/`,
    {
      floor_plan_ids: params.floorPlanIds,
      version: params.versionId,
    },
  );
  return data;
};
